import { render, staticRenderFns } from "./TutorialModal.vue?vue&type=template&id=6886aef9&scoped=true&"
import script from "./TutorialModal.vue?vue&type=script&lang=ts&"
export * from "./TutorialModal.vue?vue&type=script&lang=ts&"
import style0 from "./TutorialModal.vue?vue&type=style&index=0&id=6886aef9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886aef9",
  null
  
)

export default component.exports